<template>
  <div class="container-fluid">
    <div class="group-status">
      <template v-for="x in status">
        <div :key="x.index">
          <div class="status">
            <div
              :class="{
                color: true,
                red: x.color == 'แดง',
                yellow: x.color == 'เหลือง',
                pink: x.color == 'ชมพู',
                blue: x.color == 'ฟ้า',
                green: x.color == 'เขียว',
                gray: x.color == 'เทา',
                orange: x.color == 'ส้ม',
                purple: x.color == 'ม่วง',
              }"
            />
            <span style="margin-left:5px;">{{ x.meaning }}</span>
          </div>
        </div>
      </template>
    </div>
    <b-container id="form" fluid>
      <b-row class="px-3">
        <b-col cols="auto" class="px-1px my-1">
          <div
            class="datepicker-trigger input-group"
            style="min-width: 150px;"
            @mouseover="activeCloseDate = true"
            @mouseleave="activeCloseDate = false"
          >
            <input
              id="datepicker-trigger"
              class="form-control border-right-0"
              type="text"
              autocomplete="off"
              placeholder="เลือกวันที่"
              :value="formatDates(filter.dateOne, filter.dateTwo)"
            />
            <div class="input-group-prepend bg-white">
              <span
                id="basic-addon1"
                class="input-group-text border-left-0 rounded-right bg-white"
                ><fa-icon
                  :style="{
                    opacity: activeCloseDate ? 1 : 0,
                  }"
                  :icon="['fas', 'times']"
                  class="icon"
                  @click="clearDate"
                />
              </span>
            </div>

            <AirbnbStyleDatepicker
              :trigger-element-id="'datepicker-trigger'"
              :mode="'range'"
              :show-shortcuts-menu-trigger="false"
              :fullscreen-mobile="true"
              :date-one="filter.dateOne"
              :date-two="filter.dateTwo"
              @date-one-selected="
                (val) => {
                  filter.dateOne = val;
                }
              "
              @date-two-selected="
                (val) => {
                  filter.dateTwo = val;
                }
              "
              @apply="filters(filter)"
            />
          </div>
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <multiselect
            v-model="filter.direction"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="direction"
            label="direction"
            track-by="id"
            select-label=""
            deselect-label="✖"
            selected-label=""
            placeholder="เส้นทางวิ่ง"
            @close="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <multiselect
            v-model="filter.hospital"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="hospital"
            label="name"
            track-by="id"
            select-label=""
            deselect-label="✖"
            selected-label=""
            placeholder="สถานพยาบาล"
            @close="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.owner_name"
            type="search"
            class="form-control"
            placeholder="ชื่อเจ้าของ"
            style="min-width: 150px;"
            @input="filter.owner_name === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.hn"
            type="search"
            class="form-control"
            placeholder="HN"
            style="min-width: 150px;"
            @input="filter.hn === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.pet_name"
            type="search"
            class="form-control"
            placeholder="ชื่อสัตว์"
            style="min-width: 150px;"
            @input="filter.pet_name === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.daily_number"
            type="search"
            class="form-control"
            placeholder="Daily Number"
            style="min-width: 150px;"
            @input="filter.daily_number === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.ln"
            type="search"
            class="form-control"
            placeholder="LN"
            style="min-width: 150px;"
            @input="filter.daily_number === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <input
            v-model="filter.user"
            type="search"
            class="form-control"
            placeholder="ชื่อผู้ใช้"
            style="min-width: 150px;"
            @input="filter.daily_number === '' ? filters(filter) : null"
            @keyup.enter="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-1">
          <multiselect
            v-model="filter.status_id"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="status"
            label="meaning"
            :multiple="true"
            track-by="id"
            select-label=""
            deselect-label="✖"
            selected-label=""
            placeholder="สถานะ"
            @close="filters(filter)"
          />
        </b-col>
        <b-col cols="auto" class="px-1px my-auto">
          <b-button
            variant="link"
            block
            class="search-icon"
            @click="filters(filter)"
          >
            <fa-icon icon="search" />
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-table
      :items="items.data"
      :fields="fields"
      striped
      bordered
      responsive
      :tbody-tr-class="rowClass"
    >
      <template slot="no" slot-scope="data">
        <div class="col-right">
          {{ data.index + items.from }}
        </div>
      </template>
      <template slot="Daily NO." slot-scope="data">
        <div class="col-right">
          {{ data.item.daily_number }}
        </div>
      </template>
      <template slot="LN" slot-scope="data">
        <div class="col-right">
          {{ data.item.ln }}
        </div>
      </template>
      <template slot="วันที่สั่งตรวจ" slot-scope="data">
        <div class="col-center">
          {{ data.item.order_date }}
        </div>
      </template>
      <template slot="URGENT" slot-scope="data">
        <div
          :class="{
            'text-red': data.item.emergency_level == 1 ? true : false,
            'text-orange':
              data.item.emergency_level == 1
                ? false
                : data.item.urgency_hospital_type == 'ปกติ'
                ? false
                : true,
            'col-left': true,
          }"
        >
          {{
            data.item.emergency_level == 1
              ? "ด่วนพิเศษ" + " (" + data.item.sending_time + ")"
              : data.item.urgency_hospital_type
          }}
        </div>
      </template>
      <template slot="ชื่อสถานพยาบาล" slot-scope="data">
        <div class="col-left">
          {{ data.item.hospital_name }}
        </div>
      </template>
      <template slot="ชื่อเจ้าของ" slot-scope="data">
        <div class="col-left">
          {{ data.item.owner_name }}
        </div>
      </template>
      <template slot="ชื่อสัตว์" slot-scope="data">
        <div class="col-left">
          {{ data.item.animal_name }}
        </div>
      </template>
      <template slot="รายการตรวจ" slot-scope="data">
        <template v-for="x in data.item.list_test">
          <div :key="x" class="col-left">
            {{
              data.item.list_test.length - 1 ==
              data.item.list_test.lastIndexOf(x)
                ? x
                : x + " ,"
            }}
          </div>
        </template>
      </template>
      <template slot="สถานะ" slot-scope="data">
        <div
          :class="{
            color: true,
            red: data.item.status_id == '1',
            yellow: data.item.status_id == '2',
            pink: data.item.status_id == '3',
            blue: data.item.status_id == '4',
            green: data.item.status_id == '5',
            gray: data.item.status_id == '6',
            orange: data.item.status_id == '7',
            purple: data.item.status_id == '8',
          }"
        />
      </template>
      <template slot="ประวัติ" slot-scope="data">
        <button
          type="button"
          class="btn"
          :class="{
            'btn-secondary': data.item.status_id == 6,
            'btn-primary': data.item.status_id != 6,
          }"
          :disabled="data.item.status_id == 6"
          @click="historyModal(data.item)"
        >
          ประวัติสถานะ
        </button>
      </template>
    </b-table>
    <b-pagination
      v-model="items.current_page"
      size="md"
      :total-rows="items.total"
      :per-page="items.per_page"
      @input="getDataPerPage(items.current_page)"
    />
    <modal name="history-modal" height="auto" @closed="closeHistoryHandler">
      <div v-if="itemSelected" class="row">
        <div class="col">
          <table class="table">
            <tr>
              <td>
                สร้างโดย
              </td>
              <td>
                {{ itemSelected.createdBy ? itemSelected.createdBy.name : "-" }}
              </td>
              <td>
                {{ itemSelected.created_at ? itemSelected.created_at : "-" }}
              </td>
            </tr>
            <tr>
              <td>
                รับผลตรวจโดย
              </td>
              <td>
                {{
                  itemSelected.latestReceivedBy
                    ? itemSelected.latestReceivedBy.user.name
                    : "-"
                }}
              </td>
              <td>
                {{
                  itemSelected.latestReceivedBy
                    ? itemSelected.latestReceivedBy.created_at
                    : "-"
                }}
              </td>
            </tr>
            <tr>
              <td>
                Record ล่าสุดโดย
              </td>
              <td>
                {{
                  itemSelected.latestRecordedBy
                    ? itemSelected.latestRecordedBy.user.name
                    : "-"
                }}
              </td>
              <td>
                {{
                  itemSelected.latestRecordedBy
                    ? itemSelected.latestRecordedBy.created_at
                    : "-"
                }}
              </td>
            </tr>
            <tr>
              <td>
                Report ล่าสุดโดย
              </td>
              <td>
                {{
                  itemSelected.latestReportedBy
                    ? itemSelected.latestReportedBy.user.name
                    : "-"
                }}
              </td>
              <td>
                {{
                  itemSelected.latestRecordedBy
                    ? itemSelected.latestRecordedBy.created_at
                    : "-"
                }}
              </td>
            </tr>
            <tr>
              <td>
                Approve ล่าสุดโดย
              </td>
              <td>
                {{
                  itemSelected.latestApproveUser
                    ? itemSelected.latestApproveUser.user.name
                    : "-"
                }}
              </td>
              <td>
                {{
                  itemSelected.latestApproveUser
                    ? itemSelected.latestApproveUser.created_at
                    : "-"
                }}
              </td>
            </tr>
            <tr>
              <td>
                Reject โดย
              </td>
              <td>
                {{
                  itemSelected.latestRejectedBy
                    ? itemSelected.latestRejectedBy.user.name
                    : "-"
                }}
              </td>
              <td>
                {{
                  itemSelected.latestRejectedBy
                    ? itemSelected.latestRejectedBy.created_at
                    : "-"
                }}
              </td>
            </tr>
            <tr>
              <td>
                Cancel โดย
              </td>
              <td>
                {{
                  itemSelected.latestCanceledBy
                    ? itemSelected.latestCanceledBy.user.name
                    : "-"
                }}
              </td>
              <td>
                {{
                  itemSelected.latestCanceledBy
                    ? itemSelected.latestCanceledBy.created_at
                    : "-"
                }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment-timezone";
import format from "date-fns/format";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    // Datepicker
  },
  data() {
    return {
      activeCloseDate: false,
      fields: [
        "Daily NO.",
        "LN",
        "วันที่สั่งตรวจ",
        // A column that needs custom formatting
        "URGENT",
        "ชื่อสถานพยาบาล",
        // A regular column
        "ชื่อเจ้าของ",
        // A regular column
        "ชื่อสัตว์",
        "รายการตรวจ",
        "สถานะ",
        // A virtual column made up from two fields
        "ประวัติ",
      ],
      filter: {
        page_no: "1",
        direction: null,
        hospital: null,
        owner_name: null,
        pet_name: null,
        hn: null,
        dateOne: "",
        dateTwo: "",
        status_id: "",
        receive: true,
        daily_number: "",
        ln: "",
        user: "",
      },
      dateFormat: "D/MM/YYYY",
      reasonSelect: "",
      reason: "",
      selectedLn: null,
      listBarcode: [],
      itemSelected: null,
    };
  },
  created() {
    // this.setStatus()
  },
  mounted() {
    var today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
    // console.log(today);
    if (!this.filter.dateOne) {
      this.filter.dateOne = today;
    }
    if (!this.filter.dateTwo) {
      this.filter.dateTwo = today;
    }

    this.filters(this.filter);
  },
  computed: {
    ...mapGetters({
      items: "Order/getDataFromFilter",
      direction: "Direction/getAll",
      hospital: "Hospital/getAll",
      status: "Status/getAll",
      data: "Animal/getData",
    }),
  },
  methods: {
    // eslint-disable-next-line
    rowClass(item, type) {
      if (item.emergency_level == 1) {
        return "highlight";
      } else {
        return;
      }
    },
    ...mapActions({
      filterOrder: "Order/filterData",
      // setAll: "Order/setAll",
      setResult: "Result/setResult",
      setAnimalData: "Animal/setData",
      setCustomerData: "Hospital/setData",
      checkPermission: "Order/checkPermission",
      setStatus: "Status/setAll",
    }),
    async permission(type, mod) {
      let permission = await this.checkPermission({
        type: type,
        mod: mod,
      });

      if (!permission) {
        this.$notify({
          group: "alert",
          title: "มีข้อผิดพลาดบางอย่าง",
          text: permission,
          position: "bottom right",
          type: "error",
        });
        return false;
      }
      return true;
    },
    filters(obj) {
      let val = {};
      if (obj.dateTwo == "") {
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          hospital_id: obj.hospital != null ? obj.hospital.id : "",
          owner_name: obj.owner_name != null ? obj.owner_name : "",
          pet_name: obj.pet_name != null ? obj.pet_name : "",
          hn: obj.hn != null ? obj.hn : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateOne ? moment(obj.dateOne).format("YYYY-MM-DD") : "",
          status_id:
            obj.status_id != null && obj.status_id.length > 0
              ? obj.status_id.map((value) => value.id).join(",")
              : "",
          receive: true,
          daily_number: obj.daily_number != null ? obj.daily_number : "",
          ln: obj.ln != null ? obj.ln : "",
          user: obj.user != null ? obj.user : "",
        };
      } else {
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          hospital_id: obj.hospital != null ? obj.hospital.id : "",
          owner_name: obj.owner_name != null ? obj.owner_name : "",
          pet_name: obj.pet_name != null ? obj.pet_name : "",
          hn: obj.hn != null ? obj.hn : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateTwo ? moment(obj.dateTwo).format("YYYY-MM-DD") : "",
          status_id:
            obj.status_id != null && obj.status_id.length > 0
              ? obj.status_id.map((value) => value.id).join(",")
              : "",
          receive: true,
          daily_number: obj.daily_number != null ? obj.daily_number : "",
          ln: obj.ln != null ? obj.ln : "",
          user: obj.user != null ? obj.user : "",
        };
      }
      this.filterOrder(val);
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    clearDate() {
      this.filter.dateOne = "";
      this.filter.dateTwo = "";
      this.filters(this.filter);
    },
    getDataPerPage(pageNo) {
      this.filter.page_no = pageNo;
      this.filters(this.filter);
    },
    historyModal(item) {
      this.itemSelected = item;
      this.$modal.show("history-modal");
    },
    closeHistoryHandler() {
      this.itemSelected = null;
    },
  },
};
</script>
<style scoped>
#form {
  background-color: #eaeced;
  padding: 5px;
  /* margin-left: 1px;
  margin-right: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center; */
  /*height: 50px;*/
  /* padding: 0.5rem; */
}
.left {
  text-align: left;
}
.search-box {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.search {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.select-box {
  margin: 0px 5px 0px 5px;
  width: 20vw;
}
.search-icon {
  align-self: center;
  margin: 0px 0px 0px 10px;
  color: black;
}
.flex {
  display: flex;
  margin-right: 10px;
  margin-left: 5px;
}
a {
  color: black;
  cursor: pointer;
}
.text-red {
  color: red;
}
.text-orange {
  color: orange;
}
.date-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 15.5vw;
}
.icon {
  cursor: pointer;
}
.color {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  align-self: center;
  margin: 0 auto;
  justify-content: center;
}
.group-status {
  display: flex;
  margin-bottom: 5px;
}
.status {
  display: flex;
  margin-right: 20px;
}
.red {
  background-color: red;
}
.yellow {
  background-color: #ffe927;
}
.pink {
  background-color: pink;
}
.blue {
  background-color: #00d0ec;
}
.purple {
  background-color: #7202ec;
}
.green {
  background-color: #48e100;
}
.gray {
  background-color: gray;
}
.orange {
  background-color: #fb822b;
}
.approve-btn {
  background-color: #009906;
  border: none;
}
f .reject-btn {
  background-color: #e20000;
  border: none;
}
</style>

<style>
.date-box {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: center;
}
</style>
